// Public gateway origin shown in copy-paste snippets (Getting Started, Playground,
// Connect to Claude). Distinct from API_BASE: the SPA itself always calls the
// same-origin `/api` prefix.
//
// Canonical host is https://mcp.symone.com (owner ruling 2026-11-05, simple-mode D32:
// "repoint it to the LB"). VITE_GATEWAY_PUBLIC_URL overrides it at build time (e.g. a
// staging host); a trailing slash is dropped so URLs never contain `//mcp`.
export const CANONICAL_GATEWAY_PUBLIC_URL = 'https://mcp.symone.com'

export function resolvePublicUrl(env: string | undefined): string {
  const v = env?.trim()
  return (v ? v : CANONICAL_GATEWAY_PUBLIC_URL).replace(/\/+$/, '')
}

export const GATEWAY_PUBLIC_URL: string = resolvePublicUrl(import.meta.env.VITE_GATEWAY_PUBLIC_URL)

/** Per-workspace MCP endpoint, as configured in an MCP client's mcp.json. */
export function mcpEndpoint(workspaceId: string): string {
  return `${GATEWAY_PUBLIC_URL}/mcp/${workspaceId}`
}
